import * as React from 'react';

const SvgNavConnectedAssets = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "M17 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17 21a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM7 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM10.452 14.978a4 4 0 1 1-1.41-1.418l3.419-3.42 1.414 1.415-3.423 3.423ZM9 17a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z", clipRule: "evenodd" })
);

export { SvgNavConnectedAssets as default };
//# sourceMappingURL=NavConnectedAssets.es.js.map
